import { Home, Target, BookOpen, FileText, User } from "lucide-react";
import { cn } from "../../utils/common";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { UseAppDispatch } from "../../redux/store";
import { HIDE_SIDEBAR, SHOW_SIDEBAR } from "../../redux/types";

interface BottomNavProps {
  menu: string;
}

const BottomNav = ({ menu }: BottomNavProps) => {
  const dispatch = UseAppDispatch();
  const navItems = [
    { id: "dashboard", label: "Home", icon: Home },
    { id: "course", label: "Belajar", icon: BookOpen },
    { id: "cv-builder", label: "CV", icon: FileText },
    { id: "profile", label: "Profil", icon: User },
  ];
  const [activeMenu, setActiveMenu] = useState(menu);
  const history = useHistory();
  const goTo = (to: string) => {
    setActiveMenu(to);
    history.push(`/${to}`);
  };
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 pb-safe">
      <div className="flex justify-around items-center h-16 max-w-screen-sm mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => {
                if(item.id === 'profile') {
                  dispatch({ type: SHOW_SIDEBAR });
                }else {
                  goTo(item.id);
                }
              }}
              className={cn(
                "flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors",
                activeMenu === item.id
                  ? "text-primary"
                  : "text-muted-foreground"
              )}
            >
              <Icon
                className={cn("h-5 w-5", activeMenu === item.id && "scale-110")}
              />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
export default BottomNav;
